import { Fragment } from 'react'

import { CommentWithReplies } from 'types'

import Comment from './Comment'
import styles from './Comments.module.scss'

interface CommentsListProps {
  comments: CommentWithReplies[]
}

const Comments = ({ comments }: CommentsListProps): JSX.Element => {
  return (
    <div className={styles.root}>
      {comments.map((comment) => {
        const { replies, ...rest } = comment

        return (
          <Fragment key={comment.id}>
            <div className={styles.comment}>
              <Comment key={comment.id} comment={rest} />
            </div>
            {replies.length > 0 &&
              replies.map((reply) => (
                <div key={reply.id} className={styles.childComment}>
                  <Comment comment={reply} />
                </div>
              ))}
          </Fragment>
        )
      })}
    </div>
  )
}

export default Comments
